import { Link } from "react-router-dom";
import { gossipCategories } from "@/mocks/categories";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="CATEGORIES"
          title="按方向逛事件库"
          desc="六个稳定分类，每个方向都按合集与列表组织。想找某个领域最近发生了什么，从这里进去最快。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {gossipCategories.map((cat, index) => (
            <Reveal key={cat.slug} delay={index * 60}>
              <Link
                to={`/events?category=${encodeURIComponent(cat.name)}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:border-accent-300 hover:bg-accent-50"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                    <i className={`${cat.icon} text-xl`} />
                  </span>
                  <span className="font-heading text-sm font-bold text-foreground-500">
                    {cat.count}
                    <span className="ml-0.5 text-xs font-normal">条</span>
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 group-hover:text-accent-800">
                  {cat.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-foreground-700 group-hover:text-accent-700 whitespace-nowrap">
                  进入合集
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}